﻿import React, { useState, useEffect } from 'react';
import { TitrationBenchSheet } from '../models/titration-bench-sheet';
import { Asset } from '../models/asset';
import { ItemBasicInformation } from '../models/item-basic-information';
import ItemBasicInformationDialog from './ItemBasicInformationDialog';
import { CrudFunctions } from '../utilities/crud-functions';
import { FieldUpdate } from '../models/field-update';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { BenchSheetTechnologyType, ModalMessageType } from '../models/enums';
import { LookupItem } from '../models/lookup-item';

import SelectBox from 'devextreme-react/select-box';
import NumberBox from 'devextreme-react/number-box';
import Button from 'devextreme-react/button'
import CheckBox from 'devextreme-react/check-box'
import RadioGroup from 'devextreme-react/radio-group'
import { Popup as DialogPopup } from 'devextreme-react/popup';
import InstrumentSelectBoxTooltip from './InstrumentSelectBoxTooltip';
import SecondaryBenchSheetInstrument from './SecondaryBenchSheetInstrument';

//temp
const instrumentTypes = [
    { id: 1, name: "Manual" },
    { id: 2, name: "Auto" }
];

//temp
const driveTypes = [
    { id: 1, name: "Drive 1" },
    { id: 2, name: "Drive 2" }
];

//temp
const probeTypes = [
    { id: 1, name: "DGi113-SC" },
    { id: 2, name: "DGi111-SC" },
    { id: 3, name: "DMi140-SC" },
    { id: 4, name: "DMi141-SC" },
    { id: 5, name: "Perfect Ion Combination NO₃⁻" },
    { id: 6, name: "Perfect Ion Combination F⁻" }
];


let key = 1;

const probes = [
    { id: 1, name: 'Probe1' },
    { id: 2, name: 'Probe2' }
];

export interface Props {
    benchSheetId: string;
    isReadOnly?: boolean;
}

export default function TitrationInstrument(props: Props) {
    const [benchSheet, setBenchSheet] =
        useState<TitrationBenchSheet>();

    //const [selectedProbe, setSelectedProbe] =
    //    useState<LookupItem>();

    //const [itemBasicInformation, setItemBasicInformation] =
    //    useState<ItemBasicInformation>();

    //const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
    //    useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        if (!dataLoaded)
            getAllData();
    }, [props.benchSheetId]);

    key++;

    return (
        <div className="pw-form-container">
            {/*TODO Ask MB if informationDialog button needed; does not appear to work currently*/}
            {/*<div className="lq-header pw-margin-top-05 pw-bg-green">*/}
            {/*    <div className="lq-header-title">Titration Instrument</div>*/}
            {/*    <div className="title-bar-spacer" />*/}
            {/*    <div>*/}
            {/*        <Button className="title-bar-button"*/}
            {/*            text="" icon="info" type="success"*/}
            {/*            hint="item information"*/}
            {/*            onClick={showInformationDialog} />*/}
            {/*    </div>*/}
            {/*</div>*/}

            <SecondaryBenchSheetInstrument
                benchSheetId={props.benchSheetId}
                isReadOnly={props.isReadOnly}
                technology={BenchSheetTechnologyType.Titration}
                headerBgClass="pw-bg-green"
                title="Titration Instrument" />

            <div className="pw-form-section">
                <div className='pw-comp-row'>
                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Instrument Type</div>
                        <RadioGroup id="instrumentTypeId" items={instrumentTypes}
                            displayExpr='name' valueExpr='id' layout="horizontal"
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.instrumentTypeId ?
                                benchSheet.instrumentTypeId : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Drive</div>
                        <RadioGroup id="driveTypeId" items={driveTypes}
                            displayExpr='name' valueExpr='id' layout="horizontal"
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.driveTypeId ?
                                benchSheet.driveTypeId : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-15">
                        <div className="pw-form-unit-label">Probe</div>
                        <SelectBox id="probeId" className="selectbox"
                            placeholder='NA' readOnly={props.isReadOnly}
                            displayExpr='name' valueExpr='id'
                            dataSource={probeTypes ? probeTypes : []}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.probeId ?
                                benchSheet.probeId : null} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label"># Cycles</div>
                        <NumberBox id="numberOfCycles"
                            readOnly={props.isReadOnly}
                            className="textbox"
                            onValueChanged={onValueChanged}
                            placeholder='NA'
                            value={benchSheet && benchSheet.numberOfCycles ?
                                benchSheet.numberOfCycles : 0} />
                    </div>

                    <div className="pw-form-unit pw-comp-10">
                        <CheckBox id="burettePurged" className="pw-check-box"
                            text="Burette Purged" readOnly={props.isReadOnly}
                            onValueChanged={onValueChanged}
                            value={benchSheet && benchSheet.burettePurged ?
                                benchSheet.burettePurged : false} />
                    </div>
                </div>

                {/*
                <div className="pw-comp-row">
                    <div className="pw-comp-row pw-margin-top-05">
                        <div className="pw-form-unit pw-comp-15">
                            <div className="pw-form-unit-label">Probe</div>
                            <SelectBox readOnly={props.isReadOnly}
                                placeholder='probe'
                                valueExpr='id' displayExpr='name'
                                className="asset-selectbox"
                                height='2.1em'
                                dataSource={probes}
                                onValueChanged={onProbeChanged}
                                value={selectedProbe ? selectedProbe : undefined} />
                        </div>
                    </div>
                </div>
                */}
                {/*
                <div className="pw-flex-wrapped-row-section pw-margin-top-05">
                    <div id="instrument-left-pane">
                        <InstrumentInformation instrument={instrument} />
                    </div>

                    <div id="instrument-right-pane" className="pw-margin-left-1">

                    </div>
                </div>
                */}

                {/*{itemBasicInformationDialogVisible &&*/}
                {/*    <DialogPopup visible={itemBasicInformationDialogVisible}*/}
                {/*        onHiding={hideItemBasicInformationDialog}*/}
                {/*        title="Item Basic Information"*/}
                {/*        width={'25rem'}*/}
                {/*        height={'21rem'}*/}
                {/*        dragEnabled={false}*/}
                {/*        resizeEnabled={false}>*/}
                {/*        <ItemBasicInformationDialog initInformation={itemBasicInformation}*/}
                {/*            onOkClick={hideItemBasicInformationDialog}*/}
                {/*            key={`IBI${key}`} />*/}
                {/*    </DialogPopup>*/}
                {/*}*/}
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div>
    );

    /*
    function onProbeChanged(e: any) {
        const matchingProbe = probes.find(b => b.id === e.value);
        setSelectedProbe(matchingProbe);
    }
    */

    async function onValueChanged(e: any) {
        if (!dataLoaded)
            return;

        const caller = e.element.id as string;

        if (caller && benchSheet) {
            const bs = benchSheet as any;
            const currentValue = bs[caller];

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;
            else {
                setBenchSheet({ ...benchSheet, [caller]: e.value });

                let fieldUpdate: FieldUpdate = {
                    entity: "TitrationBenchSheets",
                    field: caller,
                    value: e.value,
                    rowId: props.benchSheetId
                };

                await updateField(fieldUpdate)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Field");
                    });
            }
        }
    }

    /*
    async function getIcpInstrumentData() {
        await CrudFunctions.getData(`benchsheets/icpinstrumentdata/${props.benchSheetId}`)
            .then(data => {
                setInstrumentData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Instrument Data");
            });
    }
    */

    //GET methods

    async function getBenchSheet() {
        await CrudFunctions.getData(`benchsheets/benchsheet/${props.benchSheetId}`)
            .then(data => {

                console.log("TITRATION BS:");
                console.log(data);

                setBenchSheet(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheet Data");
            });
    }

    /*
    async function getInstrumentLookupData() {
        await CrudFunctions.getData("benchsheets/icpinstrumentlookupdata")
            .then(data => {
                setHplcInstrumentLookupData(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Instrument Data");
            });
    }
    */

    // PUT functions

    async function updateField(fieldUpdate: FieldUpdate) {
        return CrudFunctions.putData("benchsheets/titrationbenchsheetfield", fieldUpdate);
    }

    async function getAllData() {
        await Promise.all([
            getBenchSheet(),
        ])
            .then(() => setDataLoaded(true));
    }

    //function showInformationDialog() {
    //    if (selectedInstrument) {
    //        let itemBasicInformation: ItemBasicInformation = {
    //            rowPointer: selectedInstrument.assetId,
    //            createTimestamp: selectedInstrument.createTimestamp,
    //            lastModifiedTimestamp: selectedInstrument.modifyTimestamp,
    //            createUser: selectedInstrument.createUser,
    //            modifyUser: selectedInstrument.modifyUser
    //        };

    //        setItemBasicInformation(itemBasicInformation);
    //        setItemBasicInformationDialogVisible(true);
    //    }
    //}

    //function hideItemBasicInformationDialog() {
    //    setItemBasicInformationDialogVisible(false);
    //}

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}

